import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  fontWeight,
  radius,
  screen,
  spacing
} from 'theme';
import { getPublicPath } from 'utils/paths';

export const StyledHero = styled.div`
  background-image: ${() =>
    `url('${getPublicPath('/images/helpingJuniors/bg-hero-sm.svg')}')`};
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: cover;
  padding: ${spacing('xl4')} ${spacing('md')} 0;
  margin-bottom: ${spacing('xl2')};

  @media (min-width: ${screen('md')}) {
    background-image: ${() =>
      `url('${getPublicPath('/images/helpingJuniors/bg-hero.svg')}')`};
    background-position: left 15% bottom;
    padding: ${spacing('xl4')} ${spacing('xl')} 0;
    background-position: center bottom;
    margin-bottom: ${spacing('xl4')};
    background-size: cover;
  }

  @media (min-width: ${screen('lg')}) {
    background-image: ${() =>
      `url('${getPublicPath('/images/helpingJuniors/bg-hero-lg.svg')}')`};
  }
`;

export const StyledWrapper = styled.div`
  max-width: ${container('xlMax')};
  margin: auto;
`;

export const StyledContainer = styled.div`
  color: ${color('text_white')};
  line-height: 1.5;
  text-align: center;

  @media (min-width: ${screen('md')}) {
    display: flex;
    gap: ${spacing('xl')};
    text-align: left;
  }

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.6;
    gap: ${spacing('xl3')};
  }

  img {
    max-width: 528px;
    margin-bottom: -${spacing('xl4')};

    @media (min-width: ${screen('md')}) {
      width: 50%;
      margin-bottom: 0;
      margin-top: -${spacing('xl4')};
    }
  }

  > div {
    max-width: ${container('md')};
  }
`;

export const StyledPreTitle = styled.span`
  display: block;
  margin-bottom: ${spacing('md')};
  font-size: ${fontSize('md')};
  line-height: 1.2;
  font-weight: ${fontWeight('extraBold')};
  text-transform: uppercase;
  letter-spacing: 0.25em;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
    letter-spacing: 0.35em;
  }
`;

export const StyledWarning = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${spacing('xs2')};
  background-color: ${color('white')};
  color: ${color('text_default')};
  font-size: ${fontSize('sm')};
  line-height: 1.143;
  padding: ${spacing('xs')};
  border-radius: ${radius('md')};
  font-weight: ${fontWeight('medium')};
  text-align: left;

  svg {
    color: ${color('info_500')};
  }
`;
